const STORAGE_KEY_PREFIX = 'bazaarvoice-review-feedback-v1';

export type BazaarvoiceReviewFeedbackType = 'helpfulness' | 'report';

function buildStorageKey(reviewId: string, feedbackType: BazaarvoiceReviewFeedbackType): string {
  return `${STORAGE_KEY_PREFIX}:${feedbackType}:${reviewId}`;
}

export function hasSubmittedReviewFeedback(
  reviewId: string,
  feedbackType: BazaarvoiceReviewFeedbackType
): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  try {
    return window.localStorage.getItem(buildStorageKey(reviewId, feedbackType)) === 'true';
  } catch {
    return false;
  }
}

export function setReviewFeedbackSubmitted(
  reviewId: string,
  feedbackType: BazaarvoiceReviewFeedbackType
): void {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    window.localStorage.setItem(buildStorageKey(reviewId, feedbackType), 'true');
  } catch {
    // localStorage unavailable (e.g. private browsing quota) - duplicate prevention degrades silently.
  }
}
